// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc1697e4","239":"974b8392","455":"4fece171"}[chunkId] + ".chunk.js";
};